import axios from 'axios'
import HTTP from './http'

export default {
    list: (params?: Record<string, any>) => axios.get(HTTP.MEDIWHO_APP_LECTURES, { params }),
    create: (body: Record<string, any>) => axios.post(HTTP.MEDIWHO_APP_LECTURES, body),
    update: (id: number | string, body: Record<string, any>) => axios.put(`${HTTP.MEDIWHO_APP_LECTURES}/${id}`, body),
    delete: (id: number | string) => axios.delete(`${HTTP.MEDIWHO_APP_LECTURES}/${id}`),
    listNotifications: (params?: Record<string, any>) => axios.get(HTTP.MEDIWHO_APP_NOTIFICATIONS, { params }),
    createNotification: (body: Record<string, any>) => axios.post(HTTP.MEDIWHO_APP_NOTIFICATIONS, body),
    updateNotification: (id: number | string, body: Record<string, any>) => axios.put(`${HTTP.MEDIWHO_APP_NOTIFICATIONS}/${id}`, body),
    deleteNotification: (id: number | string) => axios.delete(`${HTTP.MEDIWHO_APP_NOTIFICATIONS}/${id}`),
    getNotification: (id: number | string) => axios.get(`${HTTP.MEDIWHO_APP_NOTIFICATIONS}/${id}`),
    getNotificationRecipients: (id: number | string, page?: number) => axios.get(`${HTTP.MEDIWHO_APP_NOTIFICATIONS}/${id}/recipients`, { params: { page: page || 1 } })
}
